import { Typography, Stack, Box, Link } from "@mui/material";
import { loginWithRedirect, registerWithRedirect } from "@newsenec/auth-provider";
import { useTranslation } from "react-i18next";
import { SenecButton, useScreenSize } from "@newsenec/ui-components";

const WelcomeBanner = () => {
    const { t } = useTranslation();
    const { isMobile } = useScreenSize();
    const textColor = isMobile ? "text.light" : "text.dark";

    return (
        <Stack direction="row">
            <Box marginLeft="5vw" paddingRight="5vw">
                <Typography variant="h1" color={textColor}>
                    {t("welcomeScreenCockpitWelcomeText")}
                </Typography>
                <Typography color={textColor} marginTop="2vh">
                    {t("welcomeScreenCockpitWelcomeSubtitle")}
                </Typography>
            </Box>
        </Stack>
    );
};

const MyEnergyKeyInfo = () => {
    const { t } = useTranslation();
    const { isMobile } = useScreenSize();

    return (
        <Box
            height={isMobile ? "auto" : "100%"}
            marginLeft="5vw"
            marginBottom="5vh"
            marginTop="2vh"
            sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                alignItems: "flex-start",
            }}
        >
            <img
                src="https://cdncustomeraccesstest.azureedge.net/auth0/100/logo-mek.svg"
                alt="MyEnergyKey Icon"
                height="24px"
                style={{ marginBottom: "1vh" }}
            />
            <Typography color="text.dark">
                {t("welcomeScreenWeUseMEKPt1")}
                <Link href="https://www.enbw.com/myenergykey" target="_blank" color="text.primary">
                    {t("welcomeScreenMEK")}
                </Link>
                {t("welcomeScreenWeUseMEKPt2")}
            </Typography>
        </Box>
    );
};

export const ActionButtons = () => {
    const { t } = useTranslation();
    const { isMobile } = useScreenSize();
    const mobileProps = isMobile ? { width: "100%" } : {};

    return (
        <Box
            display="flex"
            flexDirection="column"
            justifyContent="flex-end"
            alignItems="flex-end"
            width="calc(100% - 4vw)"
            marginBottom="8vh"
            marginLeft={isMobile ? "2vw" : "0vw"}
        >
            <Stack direction={isMobile ? "column-reverse" : "row"} spacing={2} sx={mobileProps}>
                <SenecButton
                    level="secondary"
                    data-testid="login-welcome-register-btn"
                    onClick={() => registerWithRedirect()}
                    sx={mobileProps}
                >
                    {t("welcomeScreenNewlyRegisterLabel")}
                </SenecButton>
                <SenecButton
                    colorTheme="light"
                    level="primary"
                    data-testid="login-welcome-login-btn"
                    onClick={() => loginWithRedirect()}
                    sx={mobileProps}
                >
                    {t("welcomeScreenLoginLabel")}
                </SenecButton>
            </Stack>
        </Box>
    );
};

const DarkLogoSenec = () => {
    return (
        <Box display="flex" justifyContent="flex-end" margin="10% 15%">
            <img src="/senec-logo.png" alt="SENEC Logo" height="24px" />
        </Box>
    );
};

const LightLogoSenec = () => {
    return (
        <Box display="flex" justifyContent="flex-end" alignItems="flex-end" height="45vh" marginRight="6vw" paddingBottom="6vh">
            <img src="/senec-logo-white.png" alt="SENEC Logo" height="16px" />
        </Box>
    );
};

const BackgroundPanel = () => {
    const { isMobile } = useScreenSize();

    return (
        <Box
            sx={{
                flex: isMobile ? "0 0 100%" : "0 0 60%",
                backgroundImage: "url(/senec-house.webp)",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                height: isMobile ? "60vh" : "100vh",
            }}
        >
            {isMobile && (
                <>
                    <LightLogoSenec />
                    <WelcomeBanner />
                </>
            )}
        </Box>
    );
};

const ActionPanel = () => {
    const { isMobile } = useScreenSize();

    return (
        <Box
            sx={{
                flex: "0 0 40%",
                minHeight: "auto",
                display: "flex",
                flexDirection: "column",
                position: "relative",
                backgroundColor: "white !important",
            }}
        >
            {!isMobile && (
                <>
                    <DarkLogoSenec />
                    <WelcomeBanner />
                </>
            )}
            <Box display="flex" flexDirection="column" alignItems="flex-start" height="100%">
                <MyEnergyKeyInfo />
                <ActionButtons />
            </Box>
        </Box>
    );
};

export const WelcomeScreenCockpit = () => {
    const { isMobile } = useScreenSize();

    return (
        <Stack direction={isMobile ? "column" : "row"} width="100vw" height={isMobile ? "65vh" : "100vh"}>
            <BackgroundPanel />
            <ActionPanel />
        </Stack>
    );
};
